import { Field, FieldMapping } from 'types'

export const makeMapping = <T = unknown>(data: Field<T>[]): FieldMapping<T> => {
    const mapping = {} as { [key: string]: Field<T> }
    data.forEach((each) => {
        mapping[each.id] = each
    })
    return mapping
}
